import {createStrokeSVG} from './TEMPLATE'

// tabler: video
export const VideoClip_Stroke1_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4',
    'M3 8a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2l0 -8',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 1.5,
})
